import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import Nav from "@/components/Nav";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let count = 0;

    const poll = async () => {
      count += 1;
      setAttempts(count);
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (data.payment_status === "expired" || data.payment_status === "failed") {
          setStatus("failed");
          return;
        }
        if (count >= 15) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Nav />
      <div className="mx-auto max-w-2xl px-6 py-32 text-center">
        {status === "polling" && (
          <>
            <p className="text-xs font-medium uppercase tracking-[0.32em] text-stone-500">Confirmation</p>
            <h1 className="font-display mt-4 text-4xl font-light text-stone-900">Validation du paiement…</h1>
            <p className="mt-4 text-sm text-stone-500">Tentative {attempts}/15</p>
          </>
        )}
        {status === "paid" && (
          <>
            <p className="text-xs font-medium uppercase tracking-[0.32em] text-[#8B7D6B]">Bienvenue</p>
            <h1 data-testid="payment-success" className="font-display mt-4 text-5xl font-light text-stone-900">C'est confirmé.</h1>
            <p className="mt-6 max-w-md mx-auto text-base font-light text-stone-500">Votre abonnement est actif. Vous pouvez maintenant réserver vos créneaux.</p>
            <Button data-testid="go-my-space" onClick={() => nav("/mon-espace")} className="mt-10 rounded-full bg-stone-900 px-8 py-6 hover:bg-stone-800">
              Aller à mon espace
            </Button>
          </>
        )}
        {(status === "failed" || status === "error" || status === "timeout") && (
          <>
            <h1 className="font-display text-4xl font-light text-stone-900">Paiement non confirmé</h1>
            <p className="mt-4 text-sm text-stone-500">Merci de réessayer ou de contacter le support.</p>
            <Button onClick={() => nav("/")} className="mt-8 rounded-full bg-stone-900 px-8 py-6">Retour à l'accueil</Button>
          </>
        )}
      </div>
    </div>
  );
}
